import React from 'react';
import './SharedDirectorRadioGroup.css';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

export const SharedDirectorRadioGroup = ({ options, label, handleRadioGroupChange }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const selectedOption = values?.sharedDirectors;

  const handleOptionChange = (value) => {
    setFieldValue('sharedDirectors', value);
    if (value === 'No') {

      setTimeout(() => {
        setFieldValue('sharedBusinessDirectors', '');
      }, 0);

      setFieldTouched('sharedBusinessDirectors', false);
    }

    if (handleRadioGroupChange) {
      handleRadioGroupChange(value);
    }
  };

  return (
    <div className="business-radio-group">
      {label && <div className="group-label">{label}</div>}

      <div className="radio-options-wrapper">
        {options.map((option, index) => (
          <label key={index} className="radio-option">
            <div className="radio-circle">
              <div
                className={`radio-inner-circle ${selectedOption === option ? 'radioselected' : ''}`}
              />
            </div>

            <span className="radio-label">{option}</span>

            <input
              type="radio"
              value={option}
              checked={selectedOption === option}
              onChange={() => handleOptionChange(option)}
              className="radio-input"
              name="sharedDirectors"
            />
          </label>
        ))}
      </div>
    </div>
  );
};

SharedDirectorRadioGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRadioGroupChange: PropTypes.func,
  label: PropTypes.string
};
